import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ShoppingGuide from "../pages/shopping-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artigo/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/guia-de-compras",
    element: <ShoppingGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;